import React from 'react';

const HelpIcon = () => (

    <svg width="40" height="40" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
        <path d="M320 96C443.7 96 544 196.3 544 320C544 443.7 443.7 544 320 544C196.3 544 96 443.7 96 320C96 196.3 196.3 96 320 96zM320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM272 416C263.2 416 256 423.2 256 432C256 440.8 263.2 448 272 448L368 448C376.8 448 384 440.8 384 432C384 423.2 376.8 416 368 416L336 416L336 304C336 295.2 328.8 288 320 288L272 288C263.2 288 256 295.2 256 304C256 312.8 263.2 320 272 320L304 320L304 416L272 416zM320 248C333.3 248 344 237.3 344 224C344 210.7 333.3 200 320 200C306.7 200 296 210.7 296 224C296 237.3 306.7 248 320 248z"/>
    </svg>


);

export default HelpIcon;
